import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  description: [],
  Files: [],
  deletedElements: [],
};

export const fileUploadSlice = createSlice({
  name: "fileUploadSlice",
  initialState,
  reducers: {
    setDescription: (state, action) => {
      state.description.push(action.payload);
    },
    addToFile: (state, action) => {
      state.Files.push(action.payload);
    },
    emptyDescription: (state) => {
      state.description = [];
    },
    setDeletedElements: (state, action) => {
      state.deletedElements.push(action.payload);
    },
    emptyDeletedFiles: (state) => {
      state.deletedElements = [];
    },
  },
});

// Action creators are generated for each case reducer function
export const {
  setDescription,
  addToFile,
  emptyDescription,
  setEditFile,
  setDeletedElements,
  emptyDeletedFiles,
} = fileUploadSlice.actions;

export default fileUploadSlice.reducer;
